<template>
  <inertia-link :href="'/'">
    <img width="220" src="/image/logo_gheg_teal.png" class="m-auto mb-3" />
    <!-- <p class="text-vice-teal-700 my-3 text-lg font-semibold">Tesselate Education</p> -->
  </inertia-link>
</template>
